(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('user', function($rootScope, authService, agentModeService) {
        return {
            restrict: 'A',
            link(scope, el, attr) {
                if (attr.user && attr.user.length > 0) {
                    $rootScope.user = JSON.parse(attr.user);
                    authService.setUser($rootScope.user);
                    ($rootScope.user.AnonSignedIn ? authService.getSignedinBooking() : $.when()).then(booking => {
                        if (booking) {
                            $rootScope.user.Contact = booking.Contact;
                            $rootScope.user.BookingSummary = booking.Summary;
                            if (booking.Summary.DomainBookedOnId !== TRPCONFIG.Domain.DomainId) {
                                authService.signOut();
                                sessionStorage.removeItem('scope.user');
                                localStorage.removeItem('bndDetails');
                            }
                        }
                    });

                    if ($rootScope.user.Agent && !$rootScope.agent) {
                        agentModeService
                            .getAgentInformation()
                            .then(function setAgent(data) {
                                $rootScope.agent = data;
                            });
                    }
                }
            }
        };
    }
);
})();
